import { getAccessToken } from './authenticatedApi';

const OPENAI_RESPONSE_ENDPOINT = '/api/openai-response';

export const streamOpenAIResponse = async ({
    input,
    model = 'gpt-4o-mini',
    temperature = 0.7,
    onTextDelta,
}) => {
    const accessToken = await getAccessToken();
    const response = await fetch(OPENAI_RESPONSE_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ input, model, temperature }),
    });

    if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage || `OpenAI proxy request failed with status ${response.status}`);
    }

    if (!response.body) {
        const text = await response.text();
        onTextDelta?.(text, text);
        return text;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let fullResponse = '';

    while (true) {
        const { value, done } = await reader.read();

        if (done) {
            break;
        }

        const chunk = decoder.decode(value, { stream: true });
        fullResponse += chunk;
        onTextDelta?.(chunk, fullResponse);
    }

    const remainingText = decoder.decode();
    if (remainingText) {
        fullResponse += remainingText;
        onTextDelta?.(remainingText, fullResponse);
    }

    return fullResponse;
};
